import '../animation/_pageLoading.js' // ページ全体のローディング演出

/*
ContactForm7に以下の機能を付ける

・ステップ処理
　ページ遷移せずに確認画面の表示にする
　戻るボタンで戻れる

<div class="js-formArea js-validation formArea">
   [contact-form-7 id="00000" title="hoge"]
</div>

DOMイベント情報
https://contactform7.com/ja/dom-events/


ContactForm7のエディタ内では以下のようにボタンを配置する
,formAreaはmodule/_contactForm.scssを参照

*/

//  ######  #####      ###     ####  #####
//    ##    ##  ##    ## ##   ##     ##
//    ##    #####    ##   ##  ##     #####
//    ##    ##  ##   #######  ##     ##
//    ##    ##   ##  ##   ##   ####  #####
/*
確認画面用にテキストを転写する
<div class="js-formTrace--tel js-formStep-item js-formStep-item--2">
[name="tel"]の内容がここに転写される
</div>

*/

const formTraceSelector =
  '.js-formArea input:not([type="submit"]):not([type="hidden"]), .js-formArea select, .js-formArea textarea'

const placeholderSelectValues = ['', '-|', '—']

const entryValidationMessages = {
  required: '入力してください',
  select: '選択してください',
  email: 'メールアドレスの形式が正しくありません',
  tel: '電話番号の形式が正しくありません',
  privacy: '同意の上チェックしてください',
  radio: '選択してください',
}

function initEntryFormValidation() {
  document.querySelectorAll('.wpcf7-form').forEach((form) => {
    form.classList.add('init')
    form.setAttribute('novalidate', 'novalidate')
    form.noValidate = true
  })

  setupEntryErrorContainers()
  bindEntryValidationClear()
  suppressCf7ValidationUI()
}

function suppressCf7ValidationUI() {
  document.addEventListener('wpcf7invalid', clearCf7ValidationUI, false)
}

function clearCf7ValidationUI() {
  document.querySelectorAll('.wpcf7-not-valid-tip').forEach((el) => {
    el.remove()
  })

  document.querySelectorAll('.wpcf7-not-valid').forEach((el) => {
    el.classList.remove('wpcf7-not-valid')
    el.removeAttribute('aria-invalid')
  })

  document.querySelectorAll('.wpcf7-response-output').forEach((el) => {
    el.style.display = 'none'
    el.textContent = ''
  })
}

function setupEntryErrorContainers() {
  document
    .querySelectorAll('.formArea__input .entryForm__field, .formArea__input .entryForm__privacy')
    .forEach((wrap) => {
      ensureErrorEl(wrap)
    })
}

function ensureErrorEl(wrap) {
  if (!wrap) {
    return null
  }

  let errorEl = wrap.querySelector('.entryForm__error')

  if (!errorEl) {
    errorEl = document.createElement('p')
    errorEl.className = 'entryForm__error'
    errorEl.setAttribute('aria-live', 'polite')
    wrap.appendChild(errorEl)
  }

  return errorEl
}

function clearEntryFormErrors() {
  document.querySelectorAll('.formArea__input .entryForm__error').forEach((errorEl) => {
    errorEl.textContent = ''
  })

  document.querySelectorAll('.formArea__input .is-invalid').forEach((wrap) => {
    wrap.classList.remove('is-invalid')
  })
}

function showFieldError(field, message) {
  const wrap = field.closest('.entryForm__field') || field.closest('.entryForm__privacy')
  const errorEl = ensureErrorEl(wrap)

  if (errorEl) {
    errorEl.textContent = message
  }

  if (wrap) {
    wrap.classList.add('is-invalid')
  }
}

function isEmptyValue(value) {
  return !String(value ?? '').trim()
}

function isInvalidSelectValue(value) {
  return placeholderSelectValues.includes(String(value).trim())
}

function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())
}

function isValidTel(value) {
  const normalized = value.replace(/[^\d+]/g, '')
  return normalized.length >= 10
}

function scrollToEntryField(field) {
  const row = field.closest('.entryForm__row') || field
  const headerOffset = document.querySelector('.header')?.offsetHeight ?? 120
  const top = window.pageYOffset + row.getBoundingClientRect().top - headerOffset - 16

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  })

  window.setTimeout(() => {
    if (typeof field.focus === 'function') {
      field.focus({ preventScroll: true })
    }
  }, 400)
}

function scrollToFormTop() {
  const target = document.querySelector('.pEntryStep') || document.querySelector('.js-formArea')

  if (!target) {
    return
  }

  const headerOffset = document.querySelector('.header')?.offsetHeight ?? 120
  const top = window.pageYOffset + target.getBoundingClientRect().top - headerOffset - 16

  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth',
  })
}

function validateEntryForm() {
  const inputStep = document.querySelector('.formArea__input')

  if (!inputStep) {
    return true
  }

  clearEntryFormErrors()
  clearCf7ValidationUI()

  const errors = []

  inputStep.querySelectorAll('.wpcf7-validates-as-required').forEach((field) => {
    if (field.type === 'radio' || field.type === 'checkbox') {
      return
    }

    const tag = field.tagName.toLowerCase()

    if (tag === 'select') {
      if (isInvalidSelectValue(field.value)) {
        errors.push({ field, message: entryValidationMessages.select })
      }
      return
    }

    if (isEmptyValue(field.value)) {
      errors.push({ field, message: entryValidationMessages.required })
      return
    }

    if (field.type === 'email' || field.classList.contains('wpcf7-validates-as-email')) {
      if (!isValidEmail(field.value)) {
        errors.push({ field, message: entryValidationMessages.email })
      }
    }

    if (field.type === 'tel' || field.name === 'your-tel') {
      if (!isValidTel(field.value)) {
        errors.push({ field, message: entryValidationMessages.tel })
      }
    }
  })

  // 履歴書
  const resume = document.querySelector('[data-name="resume"]')
  if (resume) {
    const wrap = resume.closest('.entryForm__field')
    const complete = wrap.querySelectorAll('.dnd-upload-status.complete')
    if (complete.length <= 0) {
      errors.push({ field: resume, message: 'アップロードしてください' })
    }
  }

  const radioNames = new Set()
  inputStep.querySelectorAll('input[type="radio"].wpcf7-validates-as-required').forEach((radio) => {
    radioNames.add(radio.name)
  })

  radioNames.forEach((name) => {
    if (!inputStep.querySelector('input[type="radio"][name="' + name + '"]:checked')) {
      const field = inputStep.querySelector('input[type="radio"][name="' + name + '"]')
      if (field) {
        errors.push({ field, message: entryValidationMessages.radio })
      }
    }
  })

  inputStep.querySelectorAll('.wpcf7-acceptance input[type="checkbox"]').forEach((checkbox) => {
    if (!checkbox.checked) {
      errors.push({ field: checkbox, message: entryValidationMessages.privacy })
    }
  })

  errors.forEach(({ field, message }) => {
    showFieldError(field, message)
  })

  if (errors.length) {
    scrollToEntryField(errors[0].field)
    return false
  }

  return true
}

function bindEntryValidationClear() {
  const inputStep = document.querySelector('.formArea__input')

  if (!inputStep) {
    return
  }

  const clearFieldError = (event) => {
    const field = event.target
    const wrap = field.closest('.entryForm__field, .entryForm__privacy')

    if (!wrap || !wrap.classList.contains('is-invalid')) {
      return
    }

    wrap.classList.remove('is-invalid')

    const errorEl = wrap.querySelector('.entryForm__error')
    if (errorEl) {
      errorEl.textContent = ''
    }
  }

  inputStep.addEventListener('input', clearFieldError)
  inputStep.addEventListener('change', clearFieldError)
}

function isTraceField(element) {
  if (!element || !element.name) {
    return false
  }

  if (element.name.indexOf('_wpcf7') === 0) {
    return false
  }

  return Boolean(element.closest('.js-formArea'))
}

function syncResumeTrace() {
  const target = document.querySelector('.js-formTrace--resume')
  if (!target) {
    return
  }

  const fileNames = []

  document.querySelectorAll('.js-formArea .dnd-upload-files li').forEach((item) => {
    const removeBtn = item.querySelector('.remove-file, .dnd-icon-remove, .dnd-icon-remove-file')
    let name = item.textContent.trim()

    if (removeBtn) {
      name = name.replace(removeBtn.textContent, '').trim()
    }

    name = name.replace(/[×x✕]\s*$/i, '').trim()

    if (name) {
      fileNames.push(name)
    }
  })

  document.querySelectorAll('.js-formArea .dnd-upload-files .dnd-upload-file').forEach((item) => {
    const name = item.textContent.trim()
    if (name) {
      fileNames.push(name)
    }
  })

  document
    .querySelectorAll(
      '.js-formArea input[type="hidden"][name="resume"], .js-formArea input[type="hidden"][name="resume[]"]'
    )
    .forEach((input) => {
      if (!input.value) {
        return
      }

      const name = input.value.split(/[/\\]/).pop()
      if (name) {
        fileNames.push(name)
      }
    })

  const fileInput = document.querySelector('.js-formArea input[type="file"][name="resume"]')
  if (fileInput && fileInput.files.length) {
    Array.from(fileInput.files).forEach((file) => {
      fileNames.push(file.name)
    })
  }

  const uniqueNames = [...new Set(fileNames.filter(Boolean))]
  target.innerHTML = uniqueNames.length ? uniqueNames.map((name) => escape(name)).join('<br>') : '—'

  const elmFilename = document.querySelector('.js-formArea input[name="resume_filename"]')
  if (elmFilename) {
    elmFilename.value = fileNames.join(', ')
  }
}

function syncAllFormTraces() {
  document.querySelectorAll(formTraceSelector).forEach((field) => {
    if (isTraceField(field)) {
      inputTrace(field)
    }
  })

  syncResumeTrace()
}

function observeResumeUpload() {
  const bindObserver = (uploadArea) => {
    if (!uploadArea || uploadArea.dataset.resumeObserverBound) {
      return
    }

    uploadArea.dataset.resumeObserverBound = '1'

    const observer = new MutationObserver(() => {
      syncResumeTrace()
    })

    observer.observe(uploadArea, {
      childList: true,
      subtree: true,
      characterData: true,
    })
  }

  const uploadArea =
    document.querySelector('.js-formArea .codedropz-upload-wrapper') ||
    document.querySelector('.js-formArea .dnd-upload-files')

  bindObserver(uploadArea)

  window.setTimeout(() => {
    bindObserver(
      document.querySelector('.js-formArea .codedropz-upload-wrapper') ||
        document.querySelector('.js-formArea .dnd-upload-files')
    )
    syncResumeTrace()
  }, 1000)

  document.querySelector('.js-formArea')?.addEventListener('click', (event) => {
    if (event.target.closest('.remove-file, .dnd-icon-remove, .dnd-icon-remove-file, .cd-upload-btn')) {
      window.setTimeout(syncResumeTrace, 200)
    }
  })
}

function inputTrace(item) {
  if (!isTraceField(item)) {
    return
  }

  if (item.type === 'file' && nameFix(item.name) === 'resume') {
    syncResumeTrace()
    return
  }

  let value = ''

  if (item.type === 'checkbox' || item.type === 'radio') {
    const checkList = document.querySelectorAll('[name="' + item.name + '"]')

    for (const check of checkList) {
      if (!check.checked) {
        continue
      }
      if (value !== '') {
        value += '\n'
      }
      value += check.value
    }
  } else if (item.type === 'file') {
    if (item.files[0]) {
      value += item.files[0].name
    }
  } else {
    value += item.value
  }

  value = escape(value)
  value = value.replace(/\r?\n/g, '<br>')

  const target = document.querySelector('.js-formTrace--' + nameFix(item.name))
  if (!target) {
    return
  }

  target.innerHTML = value
}

window.addEventListener('input', function (e) {
  if (!isTraceField(e.target)) {
    return
  }
  inputTrace(e.target)
})

window.addEventListener('change', function (e) {
  if (!isTraceField(e.target)) {
    return
  }
  inputTrace(e.target)

  if (e.target.type === 'file') {
    syncResumeTrace()
  }
})

if (document.querySelector('.js-formArea')) {
  initEntryFormValidation()
  syncAllFormTraces()
  observeResumeUpload()
}

//   ####  ######  #####  #####
//  ##       ##    ##     ##  ##
//   ###     ##    #####  #####
//     ##    ##    ##     ##
//  ####     ##    #####  ##

/*
.activeの着脱で入力画面を遷移させる
各ステップはバリデーションを通過しないと進行できない
完了画面はステップ50とする（下の処理で変更可能）

<div class="js-formStep-item js-formStep-item--1">
  .js-formStep-item.js-formStep-item--1 →　そのステップの時しか.activeを付けない
</div>
<div class="js-formStep-stack js-formStep-stack--1">
  .js-formStep-stack.js-formStep-stack--1 →　そのステップ以上なら.activeを付ける
</div>

<div class="js-formStep-item js-formStep-item--50">
  完了メッセージ
</div>


ステップ移動ボタン　ボタンはステップの数だけ作る
<div class="js-formStep-item js-formStep-item--1 active">
    <button type="button" class="js-formStep" data-step="2">
        次へ
    </button>
</div>
<div class="js-formStep-item js-formStep-item--3">
    <button type="button" class="js-formStep" data-step="1">
        戻る
    </button>
    <button type="button" class="js-formStep" data-step="3">
        次へ
    </button>
</div>
*/

let nowStep = 1

// ステップ遷移関数
window.stepShift = function (step) {
  const prevStep = nowStep

  // ステップが進む場合はバリデーションを確認する
  if (step > nowStep) {
    if (!validateEntryForm()) {
      return false
    }

    syncAllFormTraces()
  }
  nowStep = step

  const resetList = document.querySelectorAll('.js-formStep-item,.js-formStep-stack')
  for (const element of resetList) {
    element.classList.remove('active')
  }

  // js-formStep-itemをアクティブにする
  const itemList = document.getElementsByClassName('js-formStep-item--' + step)
  for (const element of itemList) {
    element.classList.add('active')
  }

  // js-formStep-stackをアクティブにする　現在のステップより小さい値もアクティブにする
  for (let index = step; index > 0; index--) {
    const itemList = document.getElementsByClassName('js-formStep-stack--' + index)
    for (const element of itemList) {
      element.classList.add('active')
    }
  }

  if (step !== prevStep) {
    window.requestAnimationFrame(() => {
      scrollToFormTop()
    })
  }

  return true
}

window.getEntryFormStep = function () {
  return nowStep
}

// CF7の送信完了を確認したら最終ステップへ
document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    window.stepShift('50')
  },
  false
)

if (document.getElementsByClassName('js-formStep')[0]) {
  window.stepShift(1) // 最初にステップをリセットする
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.js-formStep')
    if (!item) {
      return
    }
    const step = parseInt(item.dataset.step, 10)
    if (!step) {
      return
    }
    window.stepShift(step)
  })
}

//   ####  #####  ##     ##  ####
//  ##     ##     ####   ##  ##  ##
//   ###   #####  ##  ## ##  ##  ##
//     ##  ##     ##    ###  ##  ##
//  ####   #####  ##     ##  ####
// 送信を行ったらローディング表示にする
if (document.getElementsByClassName('wpcf7-submit')[0]) {
  window.addEventListener('click', function (e) {
    const item = e.target.closest('.wpcf7-submit')
    if (!item) {
      return
    }
    window.pageLoading('on') // ページをローディング表示にする
  })

  // 送信処理が終わったらページのローディング表示を切る
  document.addEventListener(
    'wpcf7submit',
    function (event) {
      window.pageLoading('off')
    },
    false
  )
}

//  #####  ##     ##  ######  #####  #####
//  ##     ####   ##    ##    ##     ##  ##
//  #####  ##  ## ##    ##    #####  #####
//  ##     ##    ###    ##    ##     ##  ##
//  #####  ##     ##    ##    #####  ##   ##
// Enterキーでの送信を無効にする
// キー操作監視

const textList = document.querySelectorAll('.js-formArea input')
for (const text of textList) {
  text.addEventListener('keypress', function (e) {
    disableEnter(e)
  })
  text.addEventListener('input', function (e) {
    disableEnter(e)
  })
}

function disableEnter(e) {
  // Enterによる遷移を防止
  if (e.code && e.code === 'Enter') {
    e.preventDefault() // デフォルトのイベントを除去
    return false
  }
}

//  #####  ##   ##  ##     ##   ####
//  ##     ##   ##  ####   ##  ##
//  #####  ##   ##  ##  ## ##  ##     ########  ########
//  ##     ##   ##  ##    ###  ##
//  ##      #####   ##     ##   ####

//  #####   ####   ####    ###    #####   #####
//  ##     ##     ##      ## ##   ##  ##  ##
//  #####   ###   ##     ##   ##  #####   #####
//  ##        ##  ##     #######  ##      ##
//  #####  ####    ####  ##   ##  ##      #####
// テキストをサニタイズする
function escape(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

//  ##     ##    ###    ###    ###  #####
//  ####   ##   ## ##   ## #  # ##  ##
//  ##  ## ##  ##   ##  ##  ##  ##  #####
//  ##    ###  #######  ##      ##  ##
//  ##     ##  ##   ##  ##      ##  #####

// 配列名の「[]」を除去して扱う
function nameFix(name) {
  return name.replace('[]', '')
}

//  #####    #####   ####    ###    #####   ######   ####  ##   ##    ###
//  ##  ##   ##     ##      ## ##   ##  ##    ##    ##     ##   ##   ## ##
//  #####    #####  ##     ##   ##  #####     ##    ##     #######  ##   ##
//  ##  ##   ##     ##     #######  ##        ##    ##     ##   ##  #######
//  ##   ##  #####   ####  ##   ##  ##        ##     ####  ##   ##  ##   ##
/*
reCAPTCHAは2分でトークンがタイムアウトし判定失敗する仕様があるため、確認画面遷移と送信時にトークンを再発行する
無料枠の使用回数を余計に消費するため注意
SITE_KEYにreCAPTCHAのサイトキーを設定する
*/
document.addEventListener('DOMContentLoaded', function () {
  const SITE_KEY = ''

  if (SITE_KEY) {
    // トークンをセットする共通関数
    function updateRecaptchaToken(form) {
      return new Promise((resolve) => {
        grecaptcha.ready(function () {
          grecaptcha.execute(SITE_KEY, { action: 'confirm' }).then(function (token) {
            const field = form.querySelector('input[name="_wpcf7_recaptcha_response"]')
            if (field) {
              field.value = token
            }

            resolve()
          })
        })
      })
    }

    // 確認ボタン押下時
    document.querySelectorAll('.js-formConfirm').forEach((btn) => {
      btn.addEventListener('click', async function (e) {
        const form = btn.closest('form')
        if (!form) return

        // トークン再発行
        await updateRecaptchaToken(form)

        // ここで確認画面へのUI切替処理（既存処理に任せる）
        // 例：form.classList.add('is-confirm');
      })
    })

    // 送信直前にも再発行
    document.addEventListener(
      'wpcf7beforesubmit',
      function (event) {
        event.preventDefault()

        const form = event.target

        grecaptcha.ready(function () {
          grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(function (token) {
            const field = form.querySelector('input[name="_wpcf7_recaptcha_response"]')
            if (field) {
              field.value = token
            }

            form.dispatchEvent(new Event('submit', { cancelable: true }))
          })
        })
      },
      false
    )
  }
})
